import React from 'react';
import { Row, Col, Form, Input, Select, Radio, Divider } from 'antd';
import { useTranslation } from 'react-i18next';
import countryList from 'react-select-country-list';

import Colors from '../../../../../themes/Colors';
const BillingForm = ({
  billingInformation,
  setBillingInformation,
  handleBillingSource,
  lastBillingInfo,
  campaign,
  user,
  errors,
  billingInfDniRef,
  isSuperUser,
  campaignComment,
  setCampaignComment
}) => {
  const { t } = useTranslation();
  const optionsCountry = countryList().getData();

  const renderCountries = () =>
    optionsCountry.map(e => (
      <Select.Option key={e.value} value={e.value}>
        {e.label}
      </Select.Option>
    ));

  return (
    <Form>
      <Divider className="divider-payment" />
      <Row type="flex" xl={16} style={{ marginBottom: '50px' }}>
        <Col xs={16} sm={16} md={16} lg={16} xl={16}>
          <div className="ant-collapse-sub-header" style={{ marginTop: '30px' }}>
            {t('Fill in the following information')}
          </div>

          {user && user.company && (
            <Radio.Group
              style={{ marginBottom: 20 }}
              onChange={e => handleBillingSource(e.target.value, campaign, user)}
            >
              <Radio value="client">{t('Billing to client')}</Radio>
              <Radio value="company">{t('Billing to agency')}</Radio>
              <Radio value="lastBilling">{t('Last billing')}</Radio>
            </Radio.Group>
          )}

          <Col xs={24}>
            <p className="title-form">DNI / CUIT / RUT / NIT</p>
            <Form.Item
              validateStatus={errors['doc_number'] ? 'error' : ''}
              help={errors['doc_number']}
              name="billingDni"
              ref={billingInfDniRef}
            >
              <Input
                placeholder="XXX XXX XXX"
                value={billingInformation.doc_number}
                defaultValue={
                  billingInformation &&
                  billingInformation.doc_number &&
                  billingInformation.doc_number !== ''
                    ? billingInformation.doc_number
                    : lastBillingInfo.billing_information_doc_number
                    ? lastBillingInfo.billing_information_doc_number
                    : ''
                }
                onChange={e =>
                  setBillingInformation({
                    ...billingInformation,
                    doc_number: e.target.value
                  })
                }
              />
            </Form.Item>
          </Col>

          <Col xs={24}>
            <p className="title-form">{t('Social name')}</p>
            <Form.Item>
              <Input
                placeholder={t('Social name')}
                autoComplete="address-line1"
                value={billingInformation.first_name}
                defaultValue={lastBillingInfo.billing_information_first_name || ''}
                onChange={e => { const v = e.target.value; setBillingInformation(p => ({ ...p, first_name: v })); }}
              />
            </Form.Item>
          </Col>

          <Col xs={11}>
            <p className="title-form">{t('Billing Country')}</p>
            <Form.Item>
              <Select
                placeholder={t('Billing Country')}
                defaultValue={campaign.invoice_issuing ? campaign.invoice_issuing.alpha_2_code : ''}
                onChange={value => setBillingInformation(p => ({ ...p, address_country: value }))}
                style={{ width: '100%', paddingRight: '15px' }}
              >
                <Select.Option disabled key="" value="">
                  <span style={{ color: Colors.textMuted }}>{t('Select country')}</span>
                </Select.Option>
                {renderCountries()}
              </Select>
            </Form.Item>
          </Col>

          <Col xs={13}>
            <p className="title-form">{t('Province')}</p>
            <Form.Item>
              <Input
                placeholder={t('Province')}
                style={{ paddingRight: '15px' }}
                autoComplete="address-level1"
                value={billingInformation.address_state}
                defaultValue={lastBillingInfo.billing_information_address_state || ''}
                onChange={e => { const v = e.target.value; setBillingInformation(p => ({ ...p, address_state: v })); }}
              />
            </Form.Item>
          </Col>

          <Col xs={24}>
            <p className="title-form">{t('Address')}</p>
            <Form.Item>
              <Input
                placeholder={t('Address')}
                autoComplete="address-line1"
                value={billingInformation.address_street}
                defaultValue={lastBillingInfo.billing_information_address_street || ''}
                onChange={e => { const v = e.target.value; setBillingInformation(p => ({ ...p, address_street: v })); }}
              />
            </Form.Item>
          </Col>

          <Divider className="divider-payment" />
        </Col>
      </Row>

      {isSuperUser && (
        <>
          <Divider className="divider-payment" />
          <Row type="flex" xl={16} style={{ marginBottom: '50px' }}>
            <Col xs={16} sm={16} md={16} lg={16} xl={16}>
              <div className="ant-collapse-sub-header" style={{ marginTop: '30px' }}>
                {t('Make a comment')}
              </div>
              <Form.Item>
                <Input
                  maxLength={240}
                  placeholder={t('Add here any comments you consider relevant to your campaign')}
                  autoComplete="address-line1"
                  value={campaignComment}
                  onChange={e => setCampaignComment(e.target.value)}
                />
              </Form.Item>
            </Col>
          </Row>
        </>
      )}
    </Form>
  );
};

export default BillingForm;
